var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovilidadTransporte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "185px",
    height: "185px",
    viewBox: "0 0 185 185",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 185,
    height: 185,
    rx: 18,
    fill: "#d8a568"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.5, 68) scale(4.2) translate(-16, -16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-205.128 -164.471)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    d: "M220.731,169.162a2.384,2.384,0,1,0-1.7-2.909A2.382,2.382,0,0,0,220.731,169.162Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    d: "M220.471,185.439l.5,2.5a1.413,1.413,0,0,0,.152-.291l1.547-4.636H219.8l-.2.6.7,1.365A1.838,1.838,0,0,1,220.471,185.439Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    d: "M231.253,183.176a5.8,5.8,0,0,0-1.875.312l-1.337-4.618a.579.579,0,0,0-.553-.414h-1.472a1.116,1.116,0,0,0-.337-.361l-2.986-1.937-1.019-4.961s-.008-.021-.023-.052a2.335,2.335,0,0,0-3.149-1.639l-.035.014a2.386,2.386,0,0,0-1.227,1.1l-3.674,7.129a2.377,2.377,0,0,0,.025,2.233.9.9,0,0,0-.536.108c-.209.115-.557.414-.1,1.1a1.359,1.359,0,0,0,1.433.632l.534-.088h.158l.27.524-1.32,1.758a5.813,5.813,0,0,0-3.039-.86,5.866,5.866,0,1,0,5.464,7.984l2.037.568.006.043a1.358,1.358,0,1,0,2.664-.533l-.062-.317,6.777-7.786-.563-1.715h-8.841l.591,1.149h7.782l-6.031,6.929-.791-3.956a1.234,1.234,0,0,0-.123-.353l-2.307-4.489.621.268h5.022a1.353,1.353,0,0,0-.815-1.152l-3.727-1.6,1.5-2.921.022-.051.376,1.837a1.132,1.132,0,0,0,.488.71l3.376,2.191a1.109,1.109,0,0,0,1.538-.328c.006-.01.006-.022.014-.032h1.037l1.265,4.363a5.863,5.863,0,1,0,2.933-.793Zm-20.258,10.569a4.718,4.718,0,1,1,2.339-8.789l-2.8,3.728a.572.572,0,0,0-.085.529.587.587,0,0,0,.39.369l4.507,1.254A4.718,4.718,0,0,1,210.995,193.745Zm4.644-4.018-3.681-1.026,2.3-3.065a4.7,4.7,0,0,1,1.455,3.391A4.489,4.489,0,0,1,215.639,189.727Zm2.6.724-1.478-.41a5.752,5.752,0,0,0,.1-1.014,5.842,5.842,0,0,0-1.909-4.315l.986-1.312,1.463,2.849Zm13.011,3.323a4.72,4.72,0,0,1-2.6-8.662l.644,2.225c.795,2.1,1.687,2.28,1.941,2.288h.016a.61.61,0,0,0,.617-.555.534.534,0,0,0-.518-.584c-.005,0-.457-.173-.964-1.512l-.686-2.366a4.716,4.716,0,1,1,1.551,9.166Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 92.5,
    y: 145
  }, "Movilidad"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.5,
    dy: 22
  }, "y transporte"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovilidadTransporte);
export default __webpack_public_path__ + "static/media/Movilidad_transporte.343e4cc2cb081c0d577f6df7a4eef807.svg";
export { ForwardRef as ReactComponent };